import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { ActivatedRoute } from '@angular/router'
import { finalize, Subject, takeUntil } from 'rxjs'
import { AyBService } from 'src/app/services/api/ayb.service'
import Swal from 'sweetalert2'
import { FormCocinaService } from '../../services/forms/form-cocina.service'
import { DialogAgregarInsumoComponent } from './dialog-agregar-insumo/dialog-agregar-insumo.component'

@Component({
  selector: 'app-detalle-plato',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './detalle-plato.component.html',
  styleUrls: ['./detalle-plato.component.scss']
})
export class DetallePlatoComponent implements OnInit, OnDestroy {
  private _unsubscribeOnDestroy$ = new Subject<boolean>()
  isLoading = true
  isReadOnly = true
  dishForm!: FormGroup
  platoId!: string
  nombrePlato!: string
  buttonTitle: string = 'Modificar'
  insumos: any
  updatedInsumos: any
  displayedColumns: string[] = [
    'nombreInsumo',
    'cantidad',
    'unidadMedida',
    'eliminar'
  ]
  dataSource = new MatTableDataSource<any>()

  paginator!: MatPaginator
  @ViewChild(MatPaginator) set matPaginator (paginator: MatPaginator) {
    this.paginator = paginator
    this.dataSource.paginator = paginator
  }
  sort!: MatSort
  @ViewChild(MatSort, { static: false }) set matSort (sort: MatSort) {
    this.sort = sort
    this.dataSource.sort = sort
  }

  constructor (
    private readonly cdRef: ChangeDetectorRef,
    private readonly formService: FormCocinaService,
    private readonly aybService: AyBService,
    private readonly fb: FormBuilder,
    private readonly activatedRoute: ActivatedRoute,
    public matDialog: MatDialog
  ) {}

  ngOnInit (): void {
    this.dishForm = this.fb.group({
      dish: this.formService.getDishForm()
    })
    console.log({
      platoId: this.platoId
    })
    this.platoId = this.activatedRoute.snapshot.paramMap.get('id') ?? ''
    this.getAllInsumosByPlatoId()
  }

  ngOnDestroy (): void {
    this._unsubscribeOnDestroy$.next(true)
    this._unsubscribeOnDestroy$.complete()
  }

  getAllInsumosByPlatoId () {
    this.isLoading = true
    this.cdRef.markForCheck()

    this.aybService
      .queryGetDishById({
        dishId: this.platoId
      })
      .pipe(
        takeUntil(this._unsubscribeOnDestroy$),
        finalize(() => {
          this.isLoading = false
          this.cdRef.markForCheck()
        })
      )
      .subscribe(({ getDishById }) => {
        this.nombrePlato = getDishById?.nombrePlato || ''
        this.dishForm
          .get(['dish', 'nombre'])
          ?.setValue(getDishById?.nombrePlato)
        this.dishForm
          .get(['dish', 'categoria'])
          ?.setValue(getDishById?.categoria)
        this.dishForm
          .get(['dish', 'observaciones'])
          ?.setValue(getDishById?.observaciones)

        this.dishForm.get(['dish', 'nombre'])?.disable()
        this.dishForm.get(['dish', 'categoria'])?.disable()
        this.dishForm.get(['dish', 'observaciones'])?.disable()

        this.insumos = getDishById.insumos
        this.dataSource.data = this.insumos
        console.log({ getDishById_insumos: getDishById.insumos })
        console.log({ insumos: this.insumos })
      })
  }

  openDialogAdd (): void {
    let dialogConfig = new MatDialogConfig()

    dialogConfig.data = {
      platoId: this.platoId
    }

    dialogConfig.width = '60rem'

    let dialogAgregarInsumoComponentRef = this.matDialog.open(
      DialogAgregarInsumoComponent,
      dialogConfig
    )

    dialogAgregarInsumoComponentRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeOnDestroy$))
      .subscribe({
        next: result => {
          console.log(result)
          if (result == 1) {
            this.getAllInsumosByPlatoId()
          }
        },
        error: err => {
          console.error(err)
        }
      })
  }

  deleteInsumo (i: number): void {
    Swal.fire({
      title: `¿Desea eliminar este registro?\n"${this.insumos[i].nombreInsumo}"`,
      showCancelButton: true,
      confirmButtonText: 'Sí',
      confirmButtonColor: '#e95a1a',
      cancelButtonText: 'No'
    }).then(result => {
      if (result.isConfirmed) {
        const pageIndex = this.dataSource.paginator?.pageIndex ?? 0
        const pageSize = this.dataSource.paginator?.pageSize ?? 10
        const globalIndex = pageIndex * pageSize + i

        this.dataSource.data.splice(globalIndex, 1)

        const plato = {
          insumos: this.dataSource.data
        }

        this.aybService
          .mutationUpdatePlato({ platoId: this.platoId, plato })
          .pipe(takeUntil(this._unsubscribeOnDestroy$))
          .subscribe({
            next: ({ updatePlato }) => {
              console.log({ updatePlato })
              this.dataSource._updateChangeSubscription()
            },
            error: err => {
              console.error(err)
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo eliminar el insumo. Inténtalo de nuevo o contacta al soporte.'
              })
            }
          })

        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: `El registro "${this.insumos[i].nombreInsumo}" se eliminó con éxito.`,
          showConfirmButton: false,
          timer: 4000
        })

        this.dataSource._updateChangeSubscription()
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        console.log('false')
      }
    })
  }

  updatePlato () {
    if (this.insumos == null) {
      this.insumos = []
    }

    const plato = {
      nombrePlato: this.dishForm.value.dish.nombre,
      categoria: this.dishForm.value.dish.categoria,
      observaciones: this.dishForm.value.dish.observaciones,
      insumos: this.insumos
    }
    if (this.buttonTitle == 'Modificar') {
      this.dishForm.get(['dish', 'nombre'])?.enable()
      this.dishForm.get(['dish', 'categoria'])?.enable()
      this.dishForm.get(['dish', 'observaciones'])?.enable()
      this.isReadOnly = false
      this.buttonTitle = 'Aceptar'
      return
    }

    this.aybService
      .mutationUpdatePlato({ platoId: this.platoId, plato })
      .pipe(takeUntil(this._unsubscribeOnDestroy$))
      .subscribe({
        next: ({ updatePlato }) => {
          this.dishForm.get(['dish', 'nombre'])?.disable()
          this.dishForm.get(['dish', 'categoria'])?.disable()
          this.dishForm.get(['dish', 'observaciones'])?.disable()
          this.isReadOnly = true
          this.buttonTitle = 'Modificar'
          console.log({ updatePlato })
        },
        error: err => {
          console.error(err)
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudo actualizar el plato. Inténtalo de nuevo o contacta al soporte.'
          })
        }
      })
  }
}
